import React from 'react';
import { NotificationDisplayServiceV1 } from '@oneaudi/audi-notification-display-service';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { useI18n } from '@oneaudi/i18n-context';
import { readFilterFromLocalStore, useServicesContext, useShareUrl } from '@oneaudi/vtp-shared';
import { NextBestActionsButtonContainer, TextWrapper } from './NextBestActions.styles';
import { Text, TextLink } from '@oneaudi/unified-web-components';
import { trackShareClick } from '../tracking/Tracking';
import { SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';

export const ShareButton: React.FC = () => {
  const { getAdditionalService } = useServicesContext();
  const notificationDisplayService = getAdditionalService(
    'notification-display-service'
  ) as NotificationDisplayServiceV1;
  const trackingService = getAdditionalService('audi-tracking-service') as TrackingServiceV2;

  const copySuccessfulNotificationKey = useI18n({
    defaultMessage: 'Link copied.',
    id: 'nemo.ui.sc.link.copied.success',
  });

  const filters = readFilterFromLocalStore();
  const copyURLToShare = useShareUrl(notificationDisplayService, copySuccessfulNotificationKey);
  const shareUrl =
    typeof window !== 'undefined'
      ? `${window.location.href}${filters && !window.location.href.includes(filters) ? filters : ''}`
      : '';
  const label = useI18n({
    defaultMessage: 'Share vehicle',
    id: 'stockcars.button.share.label',
  });
  const ariaLabel = useI18n({
    defaultMessage: 'Click to share this vehicle',
    id: 'stockcars.button.share.arialabel',
  });
  const description = useI18n({
    defaultMessage: '',
    id: 'stockcars.button.share.description',
  });
  return (
    <NextBestActionsButtonContainer>
      <TextLink
        variant="standalone"
        icon="share"
        onClick={() => {
          copyURLToShare(shareUrl);
          trackShareClick(trackingService, label);
        }}
        iconPosition="leading"
        size="md"
        aria-label={ariaLabel}
        margin={[0, 0, SYS_SPACE_FIXED_100, 0]}
      >
        {label}
      </TextLink>
      <TextWrapper>
        <Text
          variant={{
            type: 'copy',
            order: '2',
            style: 'normal',
          }}
          tag="p"
        >
          {description}
        </Text>
      </TextWrapper>
    </NextBestActionsButtonContainer>
  );
};
